window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
import Set_cart from 'assets/shop/components/buttons_cart.js';
import Plus_minus from 'assets/shop/components/buttons_plus_minus.js';
import { init as Favorite } from 'assets/shop/components/favorite.js';
import { init as Layered } from 'assets/shop/components/layered.js';

(async () => {
    await Interface();
    Plus_minus();
    Set_cart();
    Favorite();
    Layered();
})();